import React from 'react';

const WinClientHomePage = () => {
	return (
		<div className="account-win-client-home-page">
			<div className="container">
				<div className="main-promo cell">
					<a
						href="#"
						className="link"
						onClick={() => {
							window.external.OpenInDefaultBrowser(
								'https://store.stamps.com/collections/netstamps?utm_source=winclient&utm_medium=print+on+stamps+warning&utm_campaign=buy+netstamps'
							);
						}}
					>
						<span className="link-text">
							Get your mail noticed with NetStamps® designs
						</span>
					</a>
				</div>
				<div className="shipping-supplies cell">
					<a
						href="#"
						className="link"
						onClick={() => {
							window.external.OpenInDefaultBrowser(
								'https://store.stamps.com/collections/shipping-supplies?utm_source=winclient&utm_medium=home+banner&utm_campaign=shipping+supplies'
							);
						}}
					>
						<span className="link-text">
							Shop our Best-Selling Shipping Supplies
						</span>
					</a>
				</div>
				<div className="thermal-labels cell">
					<a
						href="#"
						className="link"
						onClick={() => {
							window.external.OpenInDefaultBrowser(
								'https://store.stamps.com/collections/thermal-shipping-label-rolls?utm_source=winclient&utm_medium=home+widget&utm_campaign=shipping+label+rolls'
							);
						}}
					>
						<span className="link-text">
							Save on Thermal Shipping Label Rolls
						</span>
					</a>
				</div>
				<div className="postage-wizard cell">
					<a
						href="#"
						className="link"
						onClick={() => {
							window.external.MenuCommand(32896);
						}}
					>
						<span className="link-text">Try Postage Wizard</span>
					</a>
				</div>
				<div className="contact-support cell">
					<a className="link" href="mailto:support@stamps.com">
						<span className="link-text">
							Need help? Contact Support. Email support@stamps.com or call us at
							1-888-434-0055 Mon-Fri, 8AM - 8PM CT.
						</span>
					</a>
				</div>
				<div className="usps-supplies cell">
					<a
						href="#"
						className="link"
						onClick={() => {
							window.external.OpenInDefaultBrowser(
								'https://store.stamps.com/collections/free-usps-supplies?utm_source=winclient&utm_medium=home+banner&utm_campaign=free+usps+envelopes+boxes'
							);
						}}
					>
						<span className="link-text">Get Free USPS Boxes and Envelopes</span>
					</a>
				</div>
			</div>
		</div>
	);
};
export default WinClientHomePage;
